import { SETTINGS_NAV_HREF } from '@/domains/app-shell'
import { RequireSupplier } from '@/domains/auth'

/** guards the supplier-only settings routes. a buyer (or super) hitting a
 * /settings/supplier/* url directly gets bounced to the first settings page
 * instead of rendering a form for a profile they don't have.
 */
export function RequireSupplierSettings() {
  return <RequireSupplier redirectTo={SETTINGS_NAV_HREF} />
}
